var _rect, _path, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 35,
    viewBox: "0 0 61 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.30078,
    width: 60,
    height: 33,
    rx: 4.5,
    fill: "url(#paint0_linear_3933_15183)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4516 22.8008V12.619H17.9878V21.4783H22.6014V22.8008H16.4516ZM26.0301 12.619V22.8008H24.4939V12.619H26.0301ZM29.2973 12.619L32.1311 20.9116H32.2454L35.0792 12.619H36.7397L33.0757 22.8008H31.3008L27.6368 12.619H29.2973ZM38.3501 22.8008V12.619H44.7336V13.9414H39.8863V17.0437H44.4005V18.3612H39.8863V21.4783H44.7933V22.8008H38.3501Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.30078,
    width: 60,
    height: 33,
    rx: 4.5,
    stroke: "url(#paint1_linear_3933_15183)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3933_15183",
    x1: 30.5,
    y1: -5.31922,
    x2: 30.5,
    y2: 40.2408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9969FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2DD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3933_15183",
    x1: 30.5,
    y1: -5.31922,
    x2: 30.5,
    y2: 40.2408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9969FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2DD1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon12.f576e190dd9cbe40864015ece70ea1e3.svg";
export { ForwardRef as ReactComponent };